class RecentlyViewed extends HTMLElement {
  connectedCallback() {
    const currentHandle = this.dataset.productHandle;
    const limit = Number(this.dataset.limit || 4);
    const storageKey = 'loki-recent-products';
    let handles = [];

    try {
      handles = JSON.parse(localStorage.getItem(storageKey)) || [];
    } catch (error) {
      handles = [];
    }

    const previousHandles = handles.filter((handle) => handle && handle !== currentHandle).slice(0, limit);
    const updatedHandles = [currentHandle, ...handles.filter((handle) => handle !== currentHandle)].slice(0, 8);

    try {
      localStorage.setItem(storageKey, JSON.stringify(updatedHandles));
    } catch (error) {
      return;
    }

    if (!previousHandles.length) return;

    Promise.all(previousHandles.map((handle) => fetch(`${window.Shopify.routes.root}products/${handle}.js`).then((response) => {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    }).catch(() => null)))
      .then((products) => {
        const grid = this.querySelector('[data-recently-viewed-grid]');
        const cards = products.filter(Boolean).map((product) => this.renderCard(product)).join('');
        if (!cards) return;
        grid.innerHTML = cards;
        this.hidden = false;
      });
  }

  renderCard(product) {
    const image = product.featured_image;
    const imageMarkup = image
      ? `<div class="recent-card__media"><img src="${this.escape(image)}&width=720" alt="${this.escape(product.title)}" loading="lazy" width="720" height="900"></div>`
      : '<div class="recent-card__placeholder">PRODUCT IMAGE</div>';

    return `<article class="recent-card"><a href="${this.escape(product.url)}">${imageMarkup}<h3>${this.escape(product.title)}</h3></a></article>`;
  }

  escape(value) {
    const element = document.createElement('div');
    element.textContent = value || '';
    return element.innerHTML;
  }
}

if (!customElements.get('recently-viewed')) customElements.define('recently-viewed', RecentlyViewed);
